module.exports = __webpack_public_path__ + "img/41.57906004.jpg";